module.exports = __webpack_public_path__ + "static/img/2-2-1.5cfb71c5.jpg";